import type { NavItemProps } from "components/src/components/Nav/components/NavItem/types";
import { TeamLogo } from "../../TeamLogo/TeamLogo";
import { Avatar } from "components/src/components/Avatar/Avatar";
import { Icon } from "components/src/components/Icon/Icon";
import { getTeamInfo } from "shared/src/hooks/getTeamInfo";

const forceTypeMap = {
  abbr: "abbreviation",
  abbreviation: "abbreviation",
  shortname: "shortName",
  fullname: "name",
  city: "city",
  nickname: "nickName"
}

export const prepareFilters = (filters, sport, type, mode, filterDisplayAs, league?, competitionType?) => {
  const isSquares = type === "squares";
  const isSlider = type === "slider";
  
  if (isSlider) {
    return [{ id: 0, label: "Slider View" },{ id: 1, label: "List View" }];
  }

  const limitTo = competitionType !== undefined || league 
    ? { limitTo: [competitionType !== undefined ? competitionType : league] } 
    : undefined;

  const _filters =
    Array.isArray(filters) && filters.length
      ? filters.map((filter, i) => {
          let filterItem: NavItemProps | undefined = undefined;
          const foundTeam = getTeamInfo(filter, limitTo);
          const hasFoundTeam = !!foundTeam;
          const image = foundTeam && foundTeam.league === "countries" ? <Icon name={foundTeam.metadata.images?.primary?.name} /> : <TeamLogo name={filter} sport={sport} competitionType={competitionType} />;
          const avatarImage = <Avatar bgColor="bg-default" mode={mode} icon={image} size="lg" borderColor={!!foundTeam ? foundTeam.metadata.colors?.primary.value : undefined }/>
          if (typeof filter === "object") {
            let { id, label } = filter;
            const _label = hasFoundTeam && filterDisplayAs in forceTypeMap ? foundTeam[forceTypeMap[filterDisplayAs]] : label;
            filterItem = { id: id ?? i + 1, label: _label, value: label, leadingIcon: hasFoundTeam ? avatarImage : undefined };
          } else if (typeof filter === "string") {
            const _label = hasFoundTeam && filterDisplayAs in forceTypeMap ? foundTeam[forceTypeMap[filterDisplayAs]] : filter;
            filterItem = { id: i + 1, label: _label, value: filter, leadingIcon: hasFoundTeam ? avatarImage : undefined };
          }
          return filterItem;
        })
      : null;

  !isSquares && _filters?.length && _filters?.unshift({ id: 0, label: "All", value: "All" });
  return _filters;
};
